import React, { useState } from 'react'
import PropTypes from 'prop-types'

import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import classNames from 'classnames'

const EventsAccordion = ({header, body}) => {
  const [activeKey, setActiveKey] = useState(null)

  return (
    <Accordion defaultActiveKey={null}>
      <Card className="events-accordion">
        <Accordion.Toggle eventKey="0">
          <Card.Header
            as={Card.Header}
            className={classNames({
              'events-accordion-header pt-3': true,
              open: activeKey === '0',
            })}
            onClick={() => setActiveKey(activeKey && activeKey === '0' ? null : '0')}
          >
            {header}

            <div className="align-self-center ml-auto">
              <div className={`accordion-arrow ${activeKey === '0' ? 'open' : ''}`} />
            </div>
          </Card.Header>
        </Accordion.Toggle>

        <Accordion.Collapse eventKey="0">
          <Card.Body>
            {body}
          </Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  )
}

export default EventsAccordion

EventsAccordion.propTypes = {
  header: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
}